/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M2.1408 14.4334C3.219 12.108 5.5451 10.5 8.25 10.5c1.9102 0 3.6315.8019 4.8577 2.0921a6.842 6.842 0 0 1 .3705.4234.9194.9194 0 0 0 .0922.0981c.2651.2418.6603.3047.9706.1108.3538-.2211.4619-.6907.2068-1.0207a8.4212 8.4212 0 0 0-.1014-.1286l-.0119-.0148a8.3851 8.3851 0 0 0-.4656-.5289C12.6749 9.9724 10.5824 9 8.25 9 4.0118 9 .5661 12.2103.0632 16.3179A8.5621 8.5621 0 0 0 0 17.3571V18h9.75a.75.75 0 0 1 0-1.5H1.552a6.9156 6.9156 0 0 1 .3562-1.5 6.872 6.872 0 0 1 .2326-.5666ZM8.25 1.5C7.0074 1.5 6 2.5074 6 3.75S7.0074 6 8.25 6s2.25-1.0074 2.25-2.25S9.4926 1.5 8.25 1.5Zm0-1.5C10.3211 0 12 1.679 12 3.75c0 2.071-1.6789 3.75-3.75 3.75-2.071 0-3.75-1.679-3.75-3.75C4.5 1.679 6.179 0 8.25 0ZM19.5 14.25a.75.75 0 0 0-1.5 0V18h-3.75a.75.75 0 0 0 0 1.5H18v3.75a.75.75 0 0 0 1.5 0V19.5h3.75a.75.75 0 0 0 0-1.5H19.5v-3.75Z"
    clipRule="evenodd"
  />,
  'AddUser'
);
